var map = {
	"./699e9911d0abade2924f08e09774dde8.png": "2ff1",
	"./app-nestjs-angular-graphql.jpg": "6161",
	"./boursoweb.jpg": "bc89",
	"./chat_app_3.jpg": "81e1",
	"./edlib.jpg": "6b95",
	"./gyroball.jpg": "6460",
	"./ig.gif": "4256",
	"./nin.jpg": "7974",
	"./urba.jpg": "6b5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35ef";